export default __webpack_public_path__ + "static/media/SourceHanSansCN-Bold.06f996e5.ttf";